import { routeConfig as auditTrailRouteConfig } from './auditTrail';
import { routeConfig as bcpRouteConfig } from './bcp';
// import { routeConfig as committeeManagerRouteConfig } from './committeeManager';
import { routeConfig as ecatRouteConfig } from './eCAT';
import { routeConfig as enterpriseModelingRouteConfig } from './enterpriseModeling';
import { routeConfig as policyManagementRouteConfig } from './policyManagement';
import { routeConfig as vendorManagementRouteConfig } from './vendorManagement';
import { routeConfig as oversightRouteConfig } from './oversight';
import { routeConfig as praRouteConfig } from './pra';


export default function routes($routeProvider, $locationProvider) {
  $locationProvider.hashPrefix('');
  $routeProvider.when(
    '/advisory',
    { redirectTo: '/' }
  )
    .when(
      '/advisory/am',
      auditTrailRouteConfig
    )
    .when(
      '/advisory/bcp',
      bcpRouteConfig
      // ).when(
      //   '/compliance/cm',
      //   committeeManagerRouteConfig
    )
    .when(
      '/advisory/ecat',
      ecatRouteConfig
    )
    .when(
      '/advisory/enterprise-modeling',
      enterpriseModelingRouteConfig
    )
    .when(
      '/advisory/policy-management',
      policyManagementRouteConfig
    )
    .when(
      '/advisory/vendor-management',
      vendorManagementRouteConfig
    )
    .when(
      '/advisory/oversight',
      oversightRouteConfig
    )
    .when(
      '/advisory/policy-risk-assessment',
      praRouteConfig
    );
}


console.log('app.components.advisory.routes loaded');
routes.$inject = ['$routeProvider', '$locationProvider'];
